import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';

import servicioHttp from '../../../servicio/ServicioHttp';

export const Lista = (props) => {

    const [empresa, setEmpresa] = useState(null);
    const [empresas, setEmpresas] = useState([]);
    const { onSeleccionEmpresa } = props;

    useEffect(() => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            setEmpresas(response.data.lista);
        }).catch(error => {

        });
    }, []);


    const cambio = (event) => {
        setEmpresa(event.value);
        onSeleccionEmpresa(event.value);
    }

    return (
        <div className="p-grid">
            <div className="p-col-2">Empresa:</div>
            <div className="p-col-8"><Dropdown appendTo={document.body} id="empresa" name="empresa" value={empresa} options={empresas} onChange={cambio} style={{ width: '100%' }}
                filter={true} filterPlaceholder="Seleccione Empresa" filterBy="label,value" optionLabel="label" showClear={true} /></div>

        </div>
    );
}